var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45, _line46, _line47, _line48, _line49, _line50, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCakeBoxTemplate = function SvgCakeBoxTemplate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "464.99999927204937mm",
    height: "478.6875mm",
    viewBox: "3.6397533217241707e-07 4.999999999988347e-05 464.99999927204937 478.6875",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 282.4999997822587,
    x2: 382.4999997822587,
    y1: 189.3437,
    y2: 189.3437,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 432.4999997822587,
    x2: 432.4999997822587,
    y1: 216.8437,
    y2: 261.8437,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 82.49999978225874,
    x2: 182.49999978225873,
    y1: 189.3437,
    y2: 189.3437,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 32.49999978225874,
    x2: 32.49999978225874,
    y1: 216.8437,
    y2: 261.8437,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 282.4999997822587,
    x2: 382.4999997822587,
    y1: 289.3437,
    y2: 289.3437,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 82.49999978225874,
    x2: 182.49999978225873,
    y1: 289.3437,
    y2: 289.3437,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 282.4999997822587,
    x2: 282.4999997822587,
    y1: 189.3437,
    y2: 289.3437,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 182.49999978225873,
    x2: 282.4999997822587,
    y1: 187.8437,
    y2: 187.8437,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 182.49999978225873,
    x2: 282.4999997822587,
    y1: 89.3437,
    y2: 89.3437,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 382.4999997822587,
    x2: 382.4999997822587,
    y1: 189.3437,
    y2: 289.3437,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 182.49999978225873,
    x2: 182.49999978225873,
    y1: 189.3437,
    y2: 289.3437,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 82.49999978225874,
    x2: 82.49999978225874,
    y1: 189.3437,
    y2: 289.3437,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 182.49999978225873,
    x2: 282.4999997822587,
    y1: 290.8437,
    y2: 290.8437,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 182.49999978225873,
    x2: 282.4999997822587,
    y1: 389.3437,
    y2: 389.3437,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 282.4999997822587,
    x2: 282.4999997822587,
    y1: 89.3437,
    y2: 189.3437,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 322.4999997822587,
    x2: 382.4999997822587,
    y1: 129.3437,
    y2: 129.3437,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 282.4999997822587,
    x2: 322.4999997822587,
    y1: 159.3437,
    y2: 129.3437,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 382.4999997822587,
    x2: 382.4999997822587,
    y1: 129.3437,
    y2: 189.3437,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 432.4999997822587,
    x2: 432.4999997822587,
    y1: 212.9437,
    y2: 216.8437,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 432.4999997822587,
    x2: 437.4999997822587,
    y1: 216.8437,
    y2: 211.8437,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 432.4999997822587,
    x2: 437.4999997822587,
    y1: 261.8437,
    y2: 266.8437,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 382.4999997822587,
    x2: 427.4999997822587,
    y1: 189.3437,
    y2: 206.8437,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 244.99999978225873,
    x2: 282.4999997822587,
    y1: 9.8437,
    y2: 89.3437,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 182.49999978225873,
    x2: 182.49999978225873,
    y1: 89.3437,
    y2: 189.3437,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 82.49999978225874,
    x2: 142.49999978225873,
    y1: 129.3437,
    y2: 129.3437,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 142.49999978225873,
    x2: 182.49999978225873,
    y1: 129.3437,
    y2: 159.3437,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 82.49999978225874,
    x2: 82.49999978225874,
    y1: 129.3437,
    y2: 189.3437,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 32.49999978225874,
    x2: 32.49999978225874,
    y1: 212.9437,
    y2: 216.8437,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    x1: 27.49999978225874,
    x2: 32.49999978225874,
    y1: 211.8437,
    y2: 216.8437,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    x1: 32.49999978225874,
    x2: 27.49999978225874,
    y1: 261.8437,
    y2: 266.8437,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    x1: 37.49999978225874,
    x2: 82.49999978225874,
    y1: 206.8437,
    y2: 189.3437,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    x1: 219.99999978225873,
    x2: 182.49999978225873,
    y1: 9.8437,
    y2: 89.3437,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    x1: 282.4999997822587,
    x2: 282.4999997822587,
    y1: 289.3437,
    y2: 389.3437,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    x1: 322.4999997822587,
    x2: 382.4999997822587,
    y1: 349.3437,
    y2: 349.3437,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    x1: 282.4999997822587,
    x2: 322.4999997822587,
    y1: 319.3437,
    y2: 349.3437,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    x1: 382.4999997822587,
    x2: 382.4999997822587,
    y1: 289.3437,
    y2: 349.3437,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    x1: 432.4999997822587,
    x2: 432.4999997822587,
    y1: 261.8437,
    y2: 265.7437,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    x1: 382.4999997822587,
    x2: 427.4999997822587,
    y1: 289.3437,
    y2: 271.8437,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    x1: 282.4999997822587,
    x2: 244.99999978225873,
    y1: 389.3437,
    y2: 468.8437,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    x1: 182.49999978225873,
    x2: 182.49999978225873,
    y1: 289.3437,
    y2: 389.3437,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    x1: 82.49999978225874,
    x2: 142.49999978225873,
    y1: 349.3437,
    y2: 349.3437,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    x1: 142.49999978225873,
    x2: 182.49999978225873,
    y1: 349.3437,
    y2: 319.3437,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    x1: 82.49999978225874,
    x2: 82.49999978225874,
    y1: 289.3437,
    y2: 349.3437,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    x1: 32.49999978225874,
    x2: 32.49999978225874,
    y1: 261.8437,
    y2: 265.7437,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    x1: 37.49999978225874,
    x2: 82.49999978225874,
    y1: 271.8437,
    y2: 289.3437,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    x1: 182.49999978225873,
    x2: 219.99999978225873,
    y1: 389.3437,
    y2: 468.8437,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    x1: 234.49999978225873,
    x2: 234.49999978225873,
    y1: 68.8437,
    y2: 9.8437,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    x1: 230.49999978225873,
    x2: 230.49999978225873,
    y1: 68.8437,
    y2: 9.8437,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    x1: 234.49999978225873,
    x2: 234.49999978225873,
    y1: 409.8437,
    y2: 468.8437,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    x1: 230.49999978225873,
    x2: 230.49999978225873,
    y1: 409.8437,
    y2: 468.8437,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5,
    d: "M 427.5 206.8438 Q 432.5 207.8438 432.5 212.9436"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5,
    d: "M 32.5 212.9436 Q 32.5 207.9436 37.5 206.8438"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5,
    d: "M 427.5 271.8438 Q 432.5 270.8438 432.5 265.7437"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5,
    d: "M 32.5 265.7437 Q 32.5 270.7437 37.5 271.8438"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5,
    d: "M 220.0 9.8438 C 225.3571 -3.2812 239.6429 -3.2812 245.0 9.8438"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5,
    d: "M 220.0 468.8438 C 225.3571 481.9688 239.6429 481.9688 245.0 468.8438"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5,
    d: "M 437.5 211.8438 A 27.5 27.5 1 0 1 437.5 266.8438"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5,
    d: "M 27.5 211.8438 A 27.5 27.5 1 0 0 27.5 266.8438"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5,
    d: "M 230.5 9.8438 Q 230.5 9.8438 234.5 9.8438"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5,
    d: "M 230.5 68.8438 Q 230.5 68.8438 234.5 68.8438"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5,
    d: "M 230.5 409.8438 Q 230.5 409.8438 234.5 409.8438"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5,
    d: "M 230.5 468.8438 Q 230.5 468.8438 234.5 468.8438"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCakeBoxTemplate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cake-box-template.91433dc2.svg";
export { ForwardRef as ReactComponent };